import { AddressCardItem } from './AddressCardItem';
import { Button } from '@unified-checkout/design-system';
import { useAddresses } from 'apps/customer/src/services/inner_layout/addresses';
import { Spinner } from 'apps/customer/src/components';
import { AddressType } from 'apps/customer/src/types/innerLayout/addresses';
import { AddAddress } from './AddAddress';

interface AddressSectionProps {
  selectedAddressId: number | undefined;
  setSelectedAddressId: (id: number | undefined) => void;
  currentAddressType: AddressType;
  isAddingAddress?: {
    SHIPPING: boolean;
    BILLING: boolean;
  };
  setIsAddingAddress: ({isAdding, addressType}: {isAdding: boolean, addressType?: AddressType}) => void;
}

export const AddressSection = ({
  selectedAddressId,
  setSelectedAddressId,
  currentAddressType,
  isAddingAddress,
  setIsAddingAddress,
}: AddressSectionProps) => {

  const {
    data: addressesResponse,
    isLoading: isLoadingAddress,
    isFetching: isFetchingAddress,
  } = useAddresses(currentAddressType);
  return (
    <section className="space-y-3">
      <h2 className="mb-4 text-gray-500 capitalize english-body-md-semibold md:english-heading-h5-semibold md:hidden">
        {currentAddressType} Address
      </h2>
      <h2 className="hidden text-gray-500 md:mb-4 md:block md:english-utility-label-medium ">
        Your {currentAddressType.toLowerCase()} address
      </h2>
      {(isLoadingAddress || isFetchingAddress) && <Spinner />}
      {addressesResponse?.results.map((address, index) =>
        selectedAddressId === address.id ? (
          <div
            key={address.id}
            className="p-4 space-y-4 border border-gray-200 rounded-xl"
          >
            <AddressCardItem
              address={address}
              selectedAddressId={selectedAddressId}
              setSelectedAddressId={setSelectedAddressId}
              isLoadingAddress={isLoadingAddress || isFetchingAddress}
            />
            <AddAddress
              isEditing
              addressData={address}
              addressType={currentAddressType}
              setIsAddingAddress={setIsAddingAddress}
              setSelectedAddressId={setSelectedAddressId}
              isFirstAddress={index === 0}
            />
          </div>
        ) : (
          <div
            key={address.id}
            className="p-4 border border-gray-200 rounded-xl"
          >
            <AddressCardItem
              address={address}
              selectedAddressId={selectedAddressId}
              setSelectedAddressId={setSelectedAddressId}
              isLoadingAddress={isLoadingAddress || isFetchingAddress}
            />
          </div>
        )
      )}
      {isAddingAddress?.[currentAddressType] && (
        <AddAddress
          showIsDefaultCheckbox={addressesResponse?.results?.length !== 0}
          addressType={currentAddressType}
          setIsAddingAddress={setIsAddingAddress}
          setSelectedAddressId={setSelectedAddressId}
        />
      )}
      {!isAddingAddress?.[currentAddressType] && (
        <div className="mt-5 [&_span]:capitalize">
          <Button
            color="primary"
            text={`+ Add ${currentAddressType.toLowerCase()} Address`}
            size="md"
            type="button"
            variant="link"
            onClickHandler={() => setIsAddingAddress({isAdding:true, addressType:currentAddressType})}
          />
        </div>
      )}
    </section>
  );
};
